import { Trade, OrderType } from './types';

const isBlock = (trade: Trade) => {
  return trade.orderType === OrderType.Block;
};

export default isBlock;
